(() => {
  'use strict';
  // One local-day clock drives every countdown. Recompute from wall-clock time,
  // including after backgrounding or a local timezone/DST change.
  const timers = [...document.querySelectorAll('[data-countdown]')];
  function updateCountdowns() {
    const now = new Date();
    const deadline = new Date(now);
    deadline.setHours(24, 0, 0, 0);
    const seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
    const parts = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(n => String(n).padStart(2, '0'));
    timers.forEach(timer => {
      ['hours', 'minutes', 'seconds'].forEach((unit, i) => {
        const node = timer.querySelector(`[data-${unit}]`);
        if (node.textContent !== parts[i]) node.textContent = parts[i];
      });
      timer.setAttribute('aria-label', window.valeniT('js_countdown', {h:parts[0],m:parts[1],s:parts[2]}));
    });
  }
  if (timers.length) {
    updateCountdowns();
    setInterval(updateCountdowns, 1000);
    document.addEventListener('visibilitychange', updateCountdowns);
    window.addEventListener('pageshow', updateCountdowns);
  }
})();

(() => {
  const announcement = document.querySelector('.announcement');
  if (announcement) new ResizeObserver(() => document.documentElement.style.setProperty('--announcement-offset', announcement.getBoundingClientRect().height + 'px')).observe(announcement);
})();

// Keep unusually long localized heading words intact within their existing columns.
// CSS supplies the preferred size; only actual overflow triggers a smaller fit.
(() => {
  const headings = [...document.querySelectorAll('h1,h2,h3,.hero-copy>.eyebrow,.hero-status>div>span')];
  // Existing compound separators (e.g. LED-Baumbeleuchtung) are optional wrap
  // points, never new hyphens or breaks inside either constituent word.
  headings.forEach(heading => {
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT), nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      const parts = node.textContent.split(/(?<=-)(?=\p{L})/u);
      if (parts.length < 2) return;
      const fragment = document.createDocumentFragment();
      parts.forEach((part, index) => {
        if (index) fragment.append(document.createElement('wbr'));
        fragment.append(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
  });
  function fitHeading(node) {
    node.style.removeProperty('font-size');
    if (!node.clientWidth) return;
    const width = node.clientWidth;
    if (node.scrollWidth <= width + 1) return;
    let size = parseFloat(getComputedStyle(node).fontSize);
    for (let attempt = 0; attempt < 12 && node.scrollWidth > width + 1; attempt++) {
      size *= Math.min(.98, width / node.scrollWidth);
      node.style.fontSize = `${Math.floor(size * 100) / 100}px`;
    }
  }
  let frame;
  const fit = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => headings.forEach(fitHeading)); };
  const widths = new WeakMap();
  const observer = new ResizeObserver(entries => {
    if (entries.some(({target,contentRect}) => {const changed = widths.get(target) !== contentRect.width; widths.set(target,contentRect.width); return changed;})) fit();
  });
  new Set(headings.map(node => node.parentElement)).forEach(node => observer.observe(node));
  // Fit once before the first paint; observe later font/viewport changes.
  headings.forEach(fitHeading);
  document.fonts.ready.then(fit);
})();
